// extracted by mini-css-extract-plugin
export default {"root":"IconSocialMediaFacebook_root__cLDvx"};